import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseQuiz, { QuizQuestion, UserAnswer } from './BaseQuiz';
import { saveOrganicPatientQuizResults } from '../../api/patient.api';
import './Quiz.scss';

const myQuestions: QuizQuestion[] = [
    {
        id: 'oq1',
        question: 'What\'s you age?',
        type: 'single',
        options: [ '< 50', '> 50' ],
        required: true,
    },
    {
        id: 'oq2',
        question: 'How Severe is the Osteoarthritis?',
        type: 'single',
        options: [ 'Mild', 'Severe' ],
        required: true,
    },
    {
        id: 'oq3',
        question: 'Have you had Prior treatment including Cortisone Injection, PRP Injection, HA Injection, Physical Therapy or even Surgery?',
        type: 'single',
        options: [ 'No', 'Yes' ],
        required: true,
    },
];

const OrganicUsersQuiz = () => {
    const navigate = useNavigate();
    const [ isPassed, setIsPassed ] = useState(false);

    const handleComplete = async (answers: UserAnswer[]) => {
        const passed = await saveOrganicPatientQuizResults(answers.map((answer) => (
            {
                question: answer.question,
                patientAnswer: answer.questionAnswer,
                tag: answer.questionId,
            }
        )));

        if (passed) {
            setIsPassed(passed);
            setTimeout(() => navigate('/'), 5000);
        }
    };


    return (
        <div className="custom-quiz">
            {isPassed && (
                <h3>You will be redirected to home page.</h3>
            )}
            <BaseQuiz
                questions={myQuestions}
                onQuizComplete={handleComplete}
            />
        </div>
    );
};

export default OrganicUsersQuiz;